"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = videoTimeUpdate;

var _getCurrentClipFromTime = require("../clips/getCurrentClipFromTime");

var _updateVideoElement = _interopRequireDefault(require("./updateVideoElement"));

var _normaliseTime = _interopRequireDefault(require("../normaliseTime"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function onUpdateState(_ref) {
  var videoEl = _ref.videoEl,
      newCurrentClip = _ref.newCurrentClip,
      onUpdate = _ref.onUpdate;
  return function () {
    (0, _updateVideoElement.default)({
      videoEl: videoEl,
      currentClip: newCurrentClip,
      onUpdate: onUpdate
    });
  };
}

function videoTimeUpdate(_ref2) {
  var videoEl = _ref2.videoEl,
      currentClip = _ref2.currentClip,
      elapsedDuration = _ref2.elapsedDuration,
      totalDuration = _ref2.totalDuration,
      playableClips = _ref2.playableClips,
      onPause = _ref2.onPause,
      handleManualPlay = _ref2.handleManualPlay,
      loop = _ref2.loop;
  var videoCurrentTime = videoEl.currentTime;
  var clipStartNotZero = currentClip.originalDuration !== currentClip.duration || currentClip.clipStartTime;
  var videoTime = clipStartNotZero ? videoCurrentTime && videoCurrentTime - currentClip.clipStartTime : videoCurrentTime;
  var elapsedTime = elapsedDuration + (0, _normaliseTime.default)(videoTime);
  var hasReachedEnd = elapsedTime >= totalDuration;

  if (hasReachedEnd && !loop) {
    onPause();
    return null;
  }

  if (hasReachedEnd && loop) {
    return [{
      elapsedDuration: 0,
      currentTime: 0,
      currentClip: playableClips[0]
    }];
  }

  var newCurrentClip = (0, _getCurrentClipFromTime.getCurrentClipFromTime)(elapsedTime, playableClips);
  var newElapsedDuration = currentClip !== newCurrentClip ? elapsedDuration + currentClip.duration : elapsedDuration;
  var newClipIsImageOrEmpty = newCurrentClip.isImage && !currentClip.isImage || newCurrentClip.isEmpty && !currentClip.isEmpty;

  if (newClipIsImageOrEmpty) {
    videoEl.pause();
  }

  return [{
    elapsedDuration: newElapsedDuration,
    currentTime: (0, _normaliseTime.default)(elapsedTime, totalDuration),
    currentClip: newCurrentClip
  }, onUpdateState({
    videoEl: videoEl,
    newCurrentClip: newCurrentClip,
    onUpdate: newClipIsImageOrEmpty ? handleManualPlay : void 0
  })];
}